import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FeedbackBanner() {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkReminderStatus();
  }, []);

  const checkReminderStatus = async () => {
    try {
      const response = await axios.get(`${API}/feedback/reminder-status`);
      setShow(response.data.show_reminder || false);
    } catch (error) {
      // Silently fail - non-critical feature
      console.log('Feedback reminder check skipped');
    } finally {
      setLoading(false);
    }
  };

  const handleDismiss = async () => {
    try {
      await axios.post(`${API}/feedback/dismiss-reminder`);
      setShow(false);
    } catch (error) {
      console.error('Failed to dismiss reminder:', error);
      setShow(false); // Hide anyway for better UX
    }
  };

  const handleShareFeedback = () => {
    navigate('/app/profile#feedback');
    setShow(false);
  };

  if (loading || !show) return null;

  return (
    <div className="bg-blue-50 border-b border-blue-200 px-4 py-3 animate-in slide-in-from-top duration-300">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="text-blue-600 text-xl">💙</span>
          <div>
            <p className="text-sm font-medium text-blue-900">
              I'd love your feedback
            </p>
            <p className="text-xs text-blue-600">
              Help me improve MealGuide • Takes 2 minutes - Knut
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Button 
            size="sm" 
            onClick={handleShareFeedback}
            className="bg-[#3477f8] hover:bg-[#2563eb] text-white"
          >
            Share Feedback
          </Button>
          <button 
            onClick={handleDismiss}
            className="text-blue-400 hover:text-blue-600 transition-colors p-1"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
